import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import InputGroup from 'react-bootstrap/InputGroup';
import { checkRequiredFields } from 'common';
import { useForm } from 'hooks';
import showIcon from 'images/show.png';
import hideIcon from 'images/hide.png';
import './resetPasswordForm.scss';
import { ErrorChecklist } from '../common/errorChecklist';

const ResetPasswordForm = ({ reset, login }) => {
  const requiredFields = ['password', 'reenter'];
  const [maskPassword, setMaskPassword] = useState(true);
  const [maskPasswordReenter, setMaskPasswordReenter] = useState(true);

  const resetPasswordFormValidation = (values) => {
    let errors = {};
    if (
      !/^.{8,30}$/.test(values.password) ||
      !/[A-Z]+/.test(values.password) ||
      !/[a-z]+/.test(values.password) ||
      !/\d+/.test(values.password) ||
      !/^[^\s]+$/.test(values.password) ||
      !/^[^/:"&.<>`|~]+$/.test(values.password) ||
      values.password.match(new RegExp(values.login, 'i'))
    ) {
      errors.password = 'Invalid password';
    }
    if (values.password !== values.reenter) {
      errors.reenter = 'Passwords do not match';
    }
    return errors;
  };

  const passwordValidationRules = [
    ['8-30 characters', (values) => /^.{8,30}$/.test(values.password)],
    ['at least one upper case character', (values) => /[A-Z]+/.test(values.password)],
    ['at least one lower case character', (values) => /[a-z]+/.test(values.password)],
    ['at least one number', (values) => /\d+/.test(values.password)],
    ['no spaces', (values) => /^[^\s]+$/.test(values.password)],
    ['cannot use / : " & . < > ` | ~', (values) => /^[^/:"&.<>`|~]+$/.test(values.password)],
    [
      'cannot have username in password',
      (values) => values.login && !new RegExp(values.login, 'i').test(values.password),
    ],
  ];

  const defaultValues = { login, password: '', reenter: '' };
  const { values, handleBlur, handleChange, errors } = useForm(defaultValues, resetPasswordFormValidation);

  return (
    <div className="occu-form">
      <h4>PASSWORD RESET</h4>
      <Form
        name="resetForm"
        id="resetForm"
        onSubmit={(event) => {
          reset(values.password, values.reenter);
          event.preventDefault();
        }}
      >
        <Form.Group controlId="formLogin">
          <Form.Control value={values.login} type="text" name="login" autoComplete="off" hidden required />
        </Form.Group>
        <Form.Group controlId="formPassword">
          <Form.Label>Password</Form.Label>
          <InputGroup>
            <Form.Control
              value={values.password}
              type={maskPassword ? 'password' : 'text'}
              name="password"
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={errors.password}
              autoComplete="off"
              maxLength="30"
              required
            />
            <InputGroup.Append>
              <Button
                variant="light"
                tabIndex="-1"
                onClick={() => {
                  setMaskPassword(!maskPassword);
                }}
              >
                <div style={{ height: 20, width: 20 }}>
                  {maskPassword ? <Image src={showIcon} fluid /> : <Image src={hideIcon} fluid />}
                </div>
              </Button>
            </InputGroup.Append>
            <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
        <Form.Group controlId="formPasswordReenter">
          <Form.Label>Re-enter Password</Form.Label>
          <InputGroup>
            <Form.Control
              value={values.reenter}
              type={maskPasswordReenter ? 'password' : 'text'}
              name="reenter"
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={errors.reenter}
              autoComplete="off"
              maxLength="30"
              required
            />
            <InputGroup.Append>
              <Button
                variant="light"
                tabIndex="-1"
                onClick={() => {
                  setMaskPasswordReenter(!maskPasswordReenter);
                }}
              >
                <div style={{ height: 20, width: 20 }}>
                  {maskPasswordReenter ? <Image src={showIcon} fluid /> : <Image src={hideIcon} fluid />}
                </div>
              </Button>
            </InputGroup.Append>
            <Form.Control.Feedback type="invalid">{errors.reenter}</Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
        <Form.Group>
          <ErrorChecklist rules={passwordValidationRules} {...values} />
        </Form.Group>
        <Form.Group controlId="formSubmit">
          <Button
            variant="occu-primary"
            type="submit"
            block
            disabled={
              !checkRequiredFields(requiredFields, values) ||
              (Object.entries(values).length === 0 && values.constructor === Object) ||
              (Object.entries(errors).length > 0 && errors.constructor === Object)
            }
          >
            Submit
          </Button>
        </Form.Group>
      </Form>
    </div>
  );
};

export { ResetPasswordForm };
